import React from 'react';
import { Button } from '@ui';
import Loader, { LoaderSizes } from '@components/v2/Loader';
import { translate } from '@utils/i18n';
import { useWebhookStatus, useSetupWebhookMutation, useRemoveWebhookMutation } from '../hooks/useServiceTradeMutations';
const namespace = 'features.settings.service_trade';
export default function WebhookStatus({ hasIntegration }) {
    const { data: webhookData, isLoading } = useWebhookStatus(hasIntegration);
    const setupMutation = useSetupWebhookMutation();
    const removeMutation = useRemoveWebhookMutation();
    const webhook = webhookData === null || webhookData === void 0 ? void 0 : webhookData.webhook;
    const isConfigured = webhook !== null && webhook !== undefined;
    const handleSetupWebhook = () => {
        setupMutation.mutate();
    };
    const handleRemoveWebhook = () => {
        if (confirm(translate('webhook.confirm_remove', { namespace }))) {
            removeMutation.mutate();
        }
    };
    if (!hasIntegration) {
        return React.createElement(React.Fragment, null);
    }
    if (isLoading) {
        return (React.createElement("section", { className: "workspace__section" },
            React.createElement("header", { className: "section__title" },
                React.createElement("h2", { className: "section__label" }, translate('webhook.title', { namespace })),
                React.createElement("hr", { className: "section__split" })),
            React.createElement("div", { className: "connection-card" },
                React.createElement("div", { className: "connection-card__body" },
                    React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '0.5rem' } },
                        React.createElement(Loader, { size: LoaderSizes.small }),
                        React.createElement("span", null, translate('webhook.checking_status', { namespace })))))));
    }
    return (React.createElement("section", { className: "workspace__section" },
        React.createElement("header", { className: "section__title" },
            React.createElement("h2", { className: "section__label" }, translate('webhook.title', { namespace })),
            React.createElement("hr", { className: "section__split" })),
        React.createElement("div", { className: "qmb-alert--info" },
            React.createElement("i", { className: "fa-light fa-lightbulb-on alert__visual" }),
            translate('webhook.description', { namespace })),
        React.createElement("div", { className: "connection-card" }, isConfigured ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "connection-card__header" },
                React.createElement("div", { className: "connection-status connection-status--connected" },
                    React.createElement("i", { className: "fa-light fa-check-circle" }),
                    React.createElement("span", null, translate('webhook.configured', { namespace })))),
            React.createElement("div", { className: "connection-card__body" },
                React.createElement("div", { className: "connection-detail" },
                    React.createElement("label", null, translate('webhook.url_label', { namespace })),
                    React.createElement("code", { className: "webhook-url" }, webhook.url)),
                React.createElement("div", { className: "connection-detail" },
                    React.createElement("label", null, translate('webhook.status_label', { namespace })),
                    React.createElement("span", { className: `badge ${webhook.enabled ? 'badge--success' : 'badge--warning'}` }, webhook.enabled
                        ? translate('webhook.enabled', { namespace })
                        : translate('webhook.disabled', { namespace })))),
            React.createElement("div", { className: "connection-card__footer" },
                React.createElement(Button, { variant: "secondary", onClick: handleRemoveWebhook },
                    React.createElement("i", { className: "fa-light fa-trash" }),
                    translate('webhook.remove_button', { namespace }))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "connection-card__header" },
                React.createElement("div", { className: "connection-status connection-status--warning" },
                    React.createElement("i", { className: "fa-light fa-exclamation-triangle" }),
                    React.createElement("span", null, translate('webhook.not_configured', { namespace })))),
            React.createElement("div", { className: "connection-card__body" },
                React.createElement("p", { className: "connection-info-text" }, translate('webhook.not_configured_description', { namespace }))),
            React.createElement("div", { className: "connection-card__footer" },
                React.createElement(Button, { variant: "primary", onClick: handleSetupWebhook },
                    React.createElement("i", { className: "fa-light fa-plug" }),
                    translate('webhook.setup_button', { namespace }))))))));
}
